import React from 'react'

import '../../css/common/Spinner.css'

const Spinner = () => {
  return <div className="loader"></div>
}

export default Spinner
